import client from './client';

export const listDailyMessages = (params) => client.get('/daily-messages', { params });

export const createDailyMessage = (data) => client.post('/daily-messages', data);

export const updateDailyMessage = (messageId, data) => (
  client.put(`/daily-messages/${messageId}`, data)
);

export const deleteDailyMessage = (messageId) => client.delete(`/daily-messages/${messageId}`);
